import { UpdateTenantRequestSchema, UpdateTenantResponseSchema } from './update-tenant.schema';
/**
 * API Contract: Update Tenant
 * PATCH /api/v2/tenants/:tenantId
 *
 * Updates an existing tenant (super-admin only).
 * This endpoint allows super-admins to update tenant information.
 */ export const updateTenantContract = {
    method: 'PATCH',
    path: '/api/v2/tenants/:tenantId',
    description: 'Update a tenant (super-admin only)',
    requestSchema: UpdateTenantRequestSchema,
    responseSchema: UpdateTenantResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request - validation failed',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'Tenant not found',
            409: 'Conflict - slug already in use'
        }
    }
};

//# sourceMappingURL=update-tenant.contract.js.map